import React, { useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import InvitationsTable from '@features/admin/invitations/components/InvitationsTable';
import SendInvitationModal from '@features/admin/invitations/components/SendInvitationModal';
import InviteScopeSelect, { ActiveScope } from '@features/admin/invitations/components/InviteScopeSelect';
import RequirePermission from '@core/components/RequirePermission';
import { ACTION_CODES } from '@features/entity/types/actionCodes';
import { useEntityContext } from '@features/entity/hooks/usePermissions';
import { getApiScopeFromValue } from '@features/invitations/utils/getScopeFromParam';
import { SentInvitationTarget } from '@features/invitations/types/sendInvitationModalProps';

const DistrictInvitesPage: React.FC = () => {
  const { districtId } = useParams<{ districtId: string }>();
  const [showCreate, setShowCreate] = useState(false);
  const sid = Number(districtId);

  const { context } = useEntityContext();
  const [active, setActive] = useState<ActiveScope>({ scope: 'DISTRICT', scopeRefId: sid });
  const [reloadSignal, setReloadSignal] = useState(0);

  const handleSent = (target: SentInvitationTarget) => {
    if (
      getApiScopeFromValue(target.scope) === getApiScopeFromValue(active.scope) &&
      Number(target.scopeRefId) === Number(active.scopeRefId)
    ) {
      setReloadSignal((k) => k + 1);
    }
  };

  const scopeSelector = sid > 0 ? (
    <InviteScopeSelect
      ownScope="D"
      ownScopeRefId={sid}
      ownLabel="This District"
      childPluralLabel="churches"
      onChange={setActive}
      fullWidth
    />
  ) : null;

  return (
    <Container fluid className="py-4">
      <div className="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center gap-3 mb-4">
        <div className="ntcog-page-title-block mb-0">
          <h1 className="ntcog-page-heading mb-1">Invitations</h1>
          <p className="text-muted mb-0">Manage invitations for this district and its churches</p>
        </div>
        {sid > 0 && (
          <RequirePermission mode="section" action={ACTION_CODES.SEND_INVITE_DISTRICT} scopeType="DISTRICT" scopeId={sid}>
            <Button variant="primary" onClick={() => setShowCreate(true)}>
              <i className="bi bi-send me-2" aria-hidden="true"></i>
              Invite User
            </Button>
          </RequirePermission>
        )}
      </div>

      <InvitationsTable
        scope={active.scope}
        scopeRefId={active.scopeRefId}
        showPagination={true}
        leadingControl={scopeSelector}
        reloadSignal={reloadSignal}
      />

      <SendInvitationModal
        show={showCreate}
        onHide={() => setShowCreate(false)}
        scope="D"
        scopeRefId={sid > 0 ? sid : undefined}
        scopeName={context?.scopeName}
        onSent={handleSent}
      />
    </Container>
  );
};

export default DistrictInvitesPage;
